export default __webpack_public_path__ + "static/media/illustration-truck.3fe431f1.svg";